import React from 'react';
import { connect } from 'react-redux';
import EventRow from './EventRow';

const ContentTableBody = ({ events, lastFetched }) => (
  <div className="Content-tableBody Table-body">
    {events.map(event => (
      <EventRow key={event.id} event={event} />
    ))}
  </div>
);

const mapStateToProps = ({ data }) => ({
  events: data.content,
  lastFetched: data.lastFetched,
});

export default connect(mapStateToProps)(ContentTableBody);
